module.exports = __webpack_public_path__ + "static/img/p6.7240510.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/p6.png
// module id = mrT3
// module chunks = 0 1